import { Component, OnInit } from '@angular/core';
import * as xml2js from 'xml2js';
import { HttpClient } from "@angular/common/http";
import { environment } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';
import { AuthserviceService } from './../../service/authservice.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.css']
})
export class TestComponent implements OnInit {
  xmlString = `<?xml version="1.0" encoding="UTF-8"?>
  <SOAP-ENV:Envelope
  xmlns:SOAP-ENV="http://schemas.xmlsoap.org/soap/envelope/">
  <SOAP-ENV:Body>
  <ns0:ServiceResponse
  xmlns:ns0="safaricom.co.ke/Schemas/SAFService.xsd">
  <ns0:ResponseHeader>
  <ns0:ResponseRefId>979061635503</ns0:ResponseRefId>
  <ns0:ResponseCode>0</ns0:ResponseCode>
  <ns0:ResponseMsg>Success</ns0:ResponseMsg>
  </ns0:ResponseHeader>
  <ns0:Body>
  <ns1:MsisdnResponse
  xmlns:ns1="http://www.tibco.com/schemas/MusicApp/SharedResources/Schemas
  /Schema.xsd">
  <ns1:MsisdnHash>979061635503</ns1:MsisdnHash>
  <ns1:BlazeSubscriber>no</ns1:BlazeSubscriber>
  </ns1:MsisdnResponse>
  </ns0:Body>
  </ns0:ServiceResponse>
  </SOAP-ENV:Body>
  </SOAP-ENV:Envelope>`;
  xml: string;
  source: string = 'portal';
  mobile_number: string = 'NA';
  strResponse: any;
  clickId: string = 'NA';
  ipAddress: string;
  agent: string;
  pubId: string = 'NA';
  referer: string = 'NA';
  lpvisitorId: string;
  visitorId: string;
  constructor(private _activatedRoute: ActivatedRoute,
    private authService: AuthserviceService,
    private http: HttpClient,
    private _router: Router) {

  }

  async ngOnInit() {

    this.parseXmlToJson()


  }

  parseXmlToJson() {


    const parser = new xml2js.Parser({ strict: false, trim: true });
    parser.parseString(this.xmlString, (err, result) => {
      this.xml = result;
      //console.log("this.xml", this.xml['SOAP-ENV:ENVELOPE']['SOAP-ENV:BODY'][0]['NS0:SERVICERESPONSE'][0]['NS0:RESPONSEHEADER'][0]['NS0:RESPONSECODE'][0]);
      if (this.xml['SOAP-ENV:ENVELOPE']['SOAP-ENV:BODY'][0]['NS0:SERVICERESPONSE'][0]['NS0:RESPONSEHEADER'][0]['NS0:RESPONSECODE'][0] == 0) {
        // console.log("this.xml", this.xml['SOAP-ENV:ENVELOPE']['SOAP-ENV:BODY'][0]['NS0:SERVICERESPONSE'][0]['NS0:BODY'][0]['NS1:MSISDNRESPONSE'][0]['NS1:MSISDNHASH'][0]);
        this.mobile_number = this.xml['SOAP-ENV:ENVELOPE']['SOAP-ENV:BODY'][0]['NS0:SERVICERESPONSE'][0]['NS0:BODY'][0]['NS1:MSISDNRESPONSE'][0]['NS1:MSISDNHASH'][0];

        localStorage.setItem('gamezklub-mobile', this.mobile_number);
        console.log('gamezklub-mobile', this.mobile_number);
      } else {
        //switch to mobile internet msg
      }

    });

  }





}
